var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEquipePreta(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12_407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7141 3.86239C11.7141 3.86239 11.8051 1.79999 9.45292 1.79999C7.10073 1.79999 7.25469 3.8017 7.25469 3.8017L6.13786 3.79866C5.91119 3.79866 5.72729 3.98014 5.72729 4.20532V6.79333C5.72729 7.0179 5.91058 7.19999 6.13664 7.19999H12.9543C13.1804 7.19999 13.3637 7.0179 13.3637 6.79333V4.27269C13.3637 4.04872 13.181 3.86664 12.9555 3.86603L11.7141 3.86239ZM9.47369 3.951C8.77353 3.951 8.20595 3.60201 8.20595 3.17169C8.20595 2.74136 8.77353 2.39237 9.47369 2.39237C10.1738 2.39237 10.7414 2.74136 10.7414 3.17169C10.7414 3.60201 10.1738 3.951 9.47369 3.951Z",
    stroke: "#3C3C3B",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_12_407",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 4.79999H18.3153C18.744 4.79999 19.0909 5.11342 19.0909 5.50028V17.2997C19.0909 17.6866 18.7433 18 18.3153 18H0.775628C0.346905 18 0 17.6866 0 17.2997V5.50028C0 5.11342 0.34756 4.79999 0.775628 4.79999H4.09086"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15 4.29999C14.7239 4.29999 14.5 4.52385 14.5 4.79999C14.5 5.07613 14.7239 5.29999 15 5.29999V4.29999ZM4.09086 5.29999C4.367 5.29999 4.59086 5.07613 4.59086 4.79999C4.59086 4.52385 4.367 4.29999 4.09086 4.29999V5.29999ZM15 5.29999H18.3153V4.29999H15V5.29999ZM18.3153 5.29999C18.517 5.29999 18.5909 5.4363 18.5909 5.50028H19.5909C19.5909 4.79054 18.971 4.29999 18.3153 4.29999V5.29999ZM18.5909 5.50028V17.2997H19.5909V5.50028H18.5909ZM18.5909 17.2997C18.5909 17.3634 18.5167 17.5 18.3153 17.5V18.5C18.97 18.5 19.5909 18.0097 19.5909 17.2997H18.5909ZM18.3153 17.5H0.775628V18.5H18.3153V17.5ZM0.775628 17.5C0.573868 17.5 0.5 17.3637 0.5 17.2997H-0.5C-0.5 18.0094 0.119942 18.5 0.775628 18.5V17.5ZM0.5 17.2997V5.50028H-0.5V17.2997H0.5ZM0.5 5.50028C0.5 5.43656 0.574235 5.29999 0.775628 5.29999V4.29999C0.120884 4.29999 -0.5 4.79028 -0.5 5.50028H0.5ZM0.775628 5.29999H4.09086V4.29999H0.775628V5.29999Z",
    fill: "#3C3C3B",
    mask: "url(#path-2-inside-1_12_407)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4546 10.2H17.1819",
    stroke: "#3C3C3B",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4546 12H17.1819",
    stroke: "#3C3C3B",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4546 13.8H17.1819",
    stroke: "#3C3C3B",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.41504 12.6C3.41504 12.6 2.08626 13.1443 1.91705 14.5086C1.84522 15.0871 2.26704 15.6 2.81 15.6H8.00824C8.53537 15.6 8.95233 15.1152 8.90546 14.5503C8.85494 13.9424 8.5372 13.2066 7.4519 12.7313",
    stroke: "#3C3C3B",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.82014 10.3684C3.80156 9.91456 3.9192 9.46232 4.17202 9.09162C4.42484 8.72093 4.81902 8.39261 5.46345 8.40012C6.17547 8.4087 6.56192 8.79281 6.76778 9.15546C6.92825 9.43765 7.00306 9.90974 6.99996 10.2375C6.99274 10.958 6.72548 12.5663 5.40824 12.5996C4.24116 12.6285 3.85161 11.1458 3.82014 10.369V10.3684Z",
    stroke: "#3C3C3B",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12_407"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquipePreta);
export default __webpack_public_path__ + "static/media/equipe_preta.63a562a401240fb00ada3819b50139ea.svg";
export { ForwardRef as ReactComponent };